export default {
  createOrder: {
    root: '/create-order',
    addMedicine: '/create-order/medicines',
    chooseOrder: '/create-order/choose',
    selectMedicineForm: '/create-order/select-medicine-form',
    selectMedicineStrength: '/create-order/select-medicine-strength',
    reorder: '/create-order/reorder',
    basket: '/create-order/basket',
    complete: '/create-order/complete',
    summary: '/create-order/summary',
    scheduling: '/create-order/scheduling',
    changeAddress: '/create-order/change-address',
    ccSelectPharmacy: '/create-order/cc-select-pharmacy',
    ccConfirmPharmacy: '/create-order/cc-confirm-pharmacy',
  },
  login: {
    root: '/login',
    code: '/login/code',
    resend: '/login/code?resend=true',
  },
  checkout: {
    root: (orderId) => `/order/${orderId}/checkout`,
    paymentMethod: '/checkout/payment-method',
    exemptions: '/checkout/exempt/exemptions',
    uploadEvidence: '/checkout/exempt/upload-evidence',
    orderApproved: '/checkout',
    declaration: '/checkout/exempt/declaration',
    viewEvidence: '/checkout/exempt/view-evidence',
    deliveryMethod: (orderId) => `/orders/S${orderId}/change-delivery-preference`,
    paymentSummary: '/checkout/payment/summary',
    paymentDeliveryPreference: '/checkout/payment/delivery-preference',
    paymentDetails: '/checkout/payment/details',
    paymentComplete: '/checkout/payment/complete',
    complete: '/checkout/complete',
  },
  signup: {
    root: '/signup',
    password: '/signup/password',
    passwordsuccess: '/signup/passwordsuccess',
    name: '/signup/name',
    phoneAndDOB: '/signup/details',
    address: '/signup/address',
    gpDetails: '/signup/gp',
    verifyemail: '/signup/verifyemail',
    createUser: '/signup/create',
    ready: '/signup/ready',
    waiting: '/signup/waiting',
    consent: '/signup/consent',
    complete: '/signup/complete',
  },
  orders: {
    changeDeliveryAddress: (orderId) =>
      `/orders/${orderId}/change-delivery-address`,
    ccSelectPharmacy: (orderId) =>`/orders/${orderId}/cc-select-pharmacy`,
    ccConfirmPharmacy: (orderId) =>`/orders/${orderId}/cc-confirm-pharmacy/`,
  },
};
